import { useRouter } from 'next/router';
import React from 'react';

import { LIST_BY_RUBRICS } from '../../../constants/routes';
import { sendEventClickMediakit } from '../../../helpers/analytics';
import { BottomMenuLink, TRubricType } from '../../../interfaces/news';
import { createLinkProps } from '../../../utils/routing';

import { BottomMenuItem } from './BottomMenuItem';

// import { SubscriptionLink } from './SubscriptionLink';

const listRubricLink = (value: TRubricType) =>
  createLinkProps('list', LIST_BY_RUBRICS, {
    rubric: value,
  });

interface BottomMenuProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const BottomMenu = ({}: // subscriptionPopupState
BottomMenuProps) => {
  const { query } = useRouter();
  const { rubric, rubricAlias } = query;

  const handleClickAnalytics = () => sendEventClickMediakit(true);

  const bottomMenu: BottomMenuLink[] = [
    {
      name: 'Новости компаний',
      link: listRubricLink('novosti-partnerov'),
      isActive: rubric === 'novosti-partnerov' || rubricAlias === 'novosti-partnerov',
      otherProps: {},
      isExternal: false,
    },
    {
      name: 'Разместить рекламу',
      url: '/about/reklama-na-sravni/',
      isActive: false,
      otherProps: {},
      isExternal: true,
      handleClick: handleClickAnalytics,
    },
    {
      name: 'Предложить статью',
      url: '/article-proposal/',
      isActive: false,
      otherProps: {},
      isExternal: true,
    },
    {
      name: 'Наши эксперты',
      url: '/u/rating/',
      otherProps: {},
      isActive: false,
      isExternal: true,
    },
  ];

  return (
    <>
      {bottomMenu.map((item) => (
        <BottomMenuItem {...item} />
      ))}
      {/*<SubscriptionLink subscriptionPopupState={subscriptionPopupState} />*/}
    </>
  );
};
